module.exports = __webpack_public_path__ + "img/user-plus-duotone.f6aebc24.svg";